import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomHOCTable from "../../global/components/Tables/CustomHOCTable";
import { hasPermission } from "../../global/utility/permissionUtils";
import { getSitesTableColumns } from "../../model/sitesTableColumns";
import { deleteSiteRequest, fetchCountryIdsRequest, showNotificationBanner } from "../../store/actions";
import { PAGE_IDENTIFIERS } from "../../global/constants/tableConstants";
import { usePaginationReset, setDetailNavSource } from "../../hooks/usePaginationReset";

const Sites = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFromOwnDetailPage = usePaginationReset(PAGE_IDENTIFIERS.SITES);
  const [searchDevice, setSearchDevice] = useState("");
  const [selectedSite, setSelectedSite] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const dispatch = useDispatch();
  const { sites, loading, error } = useSelector((state) => state?.sitesReducer);

  useEffect(() => {
    if (location.state?.hierarchyRefreshed) return;
    dispatch(fetchCountryIdsRequest(undefined, true, false));
  }, []);

  const handleDelete = async (siteId) => {
    if (!hasPermission("Site management", "Delete")) {
      showPermissionsBanner();
    } else {
      await dispatch(deleteSiteRequest(siteId));
      dispatch(fetchCountryIdsRequest(undefined, true));
    }
  };

  const handleSiteClick = (linkUrl, record) => {
    try {
      setDetailNavSource(PAGE_IDENTIFIERS.SITES);
      navigate(linkUrl, { state: { record, mode: "edit" } });
    } catch (error) {
      console.error("Navigation failed:", error);
    }
  };

  const AddSite = () => {
    setDetailNavSource(PAGE_IDENTIFIERS.SITES);
    navigate("/AddSite");
  };
  // commented for a reason
  // if (loading) {
  //   return <Loader fullscreen={true} />;
  // }

  //should implement error boundary here
  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const columnMetaDataInfo = {
    showTableFilter: true,
    filteredInfo: {},
    siteList: sites,
    createSorterForAlertStatus: null,
    createTableFilterList: (list, key) => {
      const unique = [...new Set(list.map((item) => item[key]))];
      return unique.map((item) => ({ text: item, value: item }));
    },
    createTableFilterStaticList: null,
    GmtToLocal: null,
    navigate,
    handleDelete,
    handleSiteClick
  };

  const columns = getSitesTableColumns(columnMetaDataInfo);

  const HOCSitesTable = CustomHOCTable();

  const addSiteButton = (
    <Button
      size="medium"
      use="primary"
      data-testid="sites_addSiteButton"
      onClick={() => {
        if (!hasPermission("Site management", "Create")) {
          showPermissionsBanner();
        } else {
          AddSite();
        }
      }}
    >
      Add Site
    </Button>
  );

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link data-testid="sites_settingsLink" to="/settings" className="breadcrums-item_link">
              Settings
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>Sites</BreadcrumbItem>
        </Breadcrumbs>
      </div>
      <h2 className="breadcrumb-css">Sites</h2>

      <HOCSitesTable
        columns={columns}
        rowKey="key"
        dataList={sites}
        loading={loading}
        showSearch={true}
        searchTextPlaceholder={"Search sites"}
        extraAction={addSiteButton}
        pageIdentifier={PAGE_IDENTIFIERS.SITES}
        useReduxPersistence={true}
      />
    </>
  );
};

export default Sites;
